<template>
    <div class="row subcategoriesCreate-block mt-4">
        <div class="col-xl-12 col-xxl-12 p-lr-0-sm">
            <div class="row multisteps-form">
                <div class="col-sm-12 col-md-7 col-lg-7 col-xl-8 col-xxl-7 p-lr-0-sm">
                    <form class="multisteps-form__form dis-flex flex-column" @submit.prevent>
                        <div class="card p-3 dis-flex flex-column mb-4 multisteps-form__content col-sm-12">
                            <div class="row">
                                <div class="col-sm-12 p-lr-0-sm">
                                    <div class="dis-flex col-12 p-0">
                                        <div class="col-7 p-0 dis-flex flex-m"><i class="uis uis-align-left mr-2 text-rose"></i>
                                            <h5 class="text-sm-b">Create Subcategory</h5>
                                        </div>
                                        <div class="col-5 p-0 ml-auto">
                                            <div class="uploaded-user-icon-show w-full dis-flex flex-m flex-r" v-if="createSubCategory.icon">
                                                <small class="text-success txt-italic mr-2">Uploaded icon -</small>
                                                <div class="any-category-user-icon" :style="{'background-image': `url(data:image/png;base64,${createSubCategory.icon})`}"></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt-3">
                                        <div class="col-sm-7 p-lr-0-sm mb-2">
                                            <label>Category</label>
                                            <div class="pos-relative">
                                                <select class="multisteps-form__input form-control pointer" @change="createSubCategory.category_id = $event.target.value">
                                                    <option :selected="createSubCategory.category_id === null" disabled="" hidden>Choose Category</option>
                                                    <option v-for="(thisCategory) in categoriesList" :key="thisCategory.id" :value="thisCategory.id" :selected="createSubCategory.category_id == thisCategory.id">{{ componentsGetNormalName(thisCategory.name) }}</option>
                                                </select>
                                                <i class="uis uis-angle-down pos-absolute selector-angle-down fs-20 pointer-none text-rose"></i>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt-3">
                                        <div class="col-8 col-lg-7 p-lr-0-sm mt-3">
                                            <div class="col-sm-12 p-0 dis-flex">
                                                <div class="col-9 col-lg-10 p-0">
                                                    <div class="dis-flex flex-m flex-sb multisteps-form__content">
                                                        <label>Name</label>
                                                        <div class="btn small-form-btn fs-10 pointer" title="Translations Languages">
                                                            <select class="translate-lang-swich pointer text-uppercase" name="translation-lang" @change="createSubCategory.selected_lang = $event.target.value">
                                                                <option v-for="(thisName, thisNameKey) in createSubCategory.name" :key="thisNameKey" :value="thisNameKey" :selected="createSubCategory.selected_lang == thisNameKey">{{ thisNameKey }}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <template v-for="(thisName, thisNameKey) in createSubCategory.name" :key="thisNameKey">
                                                        <input v-if="createSubCategory.selected_lang == thisNameKey" class="multisteps-form__input form-control" type="text" placeholder="Subcategory Name" v-model="createSubCategory.name[thisNameKey]">
                                                    </template>
                                                </div>
                                                <div class="col-3 col-lg-3 dis-flex flex-column flex-m pr-0">
                                                    <div class="dis-flex flex-m flex-sb multisteps-form__content">
                                                        <label class="mb-0">Icon</label>
                                                    </div>
                                                    <div class="pick-an-icon mt-auto pointer">
                                                        <label class="pointer" for="categoryIcon">
                                                            <i class="uis uis-scenery mr-2 fs-25 pointer"></i>
                                                        </label>
                                                        <input accept="image/png, image/jpeg" type="file" @change="uploadSubCategoryIcon($event)" id="categoryIcon">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-4 col-lg-5 dis-flex flex-column mt-auto p-0">
                                            <div class="col-sm-12 p-lr-0-sm dis-flex">
                                                <button class="btn button-create-atrb-btn ml-auto" type="button" title="Create SubCategory" :disabled="(!componentsAttributesIsAllNamesLength(createSubCategory.name, 3) || createSubCategory.category_id === null)" @click="createNewSubCategory()">Create</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="col-sm-12 col-md-5 col-lg-5 col-xl-4 col-xxl-5 p-lr-0-sm">
                    <div class="card multisteps-form__content p-3 dis-flex flex-column mb-4 max-h-c100-210vh">
                        <div class="dis-flex flex-m flex-sb col-12 p-0 mb-3">
                            <div class="dis-flex flex-m">
                                <i class="uis uis-align-left mr-2 text-rose"></i>
                                <h5 class="text-sm-b">All Subcategories</h5>
                            </div>
                            <small class="text-rose txt-italic">Created</small>
                        </div>
                        <div class="content-crds-messages-scroll">
                            <template v-for="(thisCategoryArray, thisCategoryId) in subCategoriesList" :key="thisCategoryId">
                                <div class="row mb-2" v-for="thisSubCategory in thisCategoryArray.data" :key="thisSubCategory.id">
                                    <div class="col-sm-12 p-lr-0-sm">
                                        <div class="bg-white-list">
                                            <div class="dis-flex flex-m flex-sb">
                                                <div class="dis-flex flex-m">
                                                    <div class="mr-2 any-category-user-icon" v-if="thisSubCategory.icon" :style="{'background-image': `url(data:image/png;base64,${thisSubCategory.icon})`}"></div>
                                                    <h5 class="text-sm-b">{{ componentsGetNormalName(thisSubCategory.name) }}</h5>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import componentsGetNormalName from '@/mixins/componentsGetNormalName.js'

export default {
    mixins: [componentsGetNormalName],
    props: {
        categoriesList: {
            type: Array,
            required: true
        },
        subCategoriesList: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            createSubCategory: {
                selected_lang: 'en',
                category_id: null,
                name: {},
                icon: null,
            }
        }
    },
    methods: {
        createNewSubCategory: function() {
            let thisNewSubCategoryData = JSON.parse(JSON.stringify(this.createSubCategory))
            let newSubCategoryData = {
                id: (Math.floor(Math.random() * 100000000) + 100000),
                category_id: thisNewSubCategoryData.category_id,
                name: thisNewSubCategoryData.name,
                icon: thisNewSubCategoryData.icon,
            }
            socket.emit('categories:createSubCategory', newSubCategoryData, (success) => {
                this.$emit('updateSubCategoryList')
            })
            if (this.subCategoriesList.hasOwnProperty(`${thisNewSubCategoryData.category_id}`)) {
                this.subCategoriesList[`${thisNewSubCategoryData.category_id}`].data.push(newSubCategoryData)
            } else {
                this.subCategoriesList[`${thisNewSubCategoryData.category_id}`] = {
                    opened: false,
                    data: [newSubCategoryData]
                }
            }

            this.createSubCategory.selected_lang = 'en'
            this.createSubCategory.icon = null
            this.createSubCategory.category_id = null
            for (const key in this.createSubCategory.name) {
                this.createSubCategory.name[key] = ''
            }
        },
        componentsAttributesIsAllNamesLength: function(thisNameObj, minLength) {
            let allNameIsWithMinLength = true

            for (const key in thisNameObj) {
                const thisName = thisNameObj[key]
                if (thisName.length < minLength) {
                    allNameIsWithMinLength = false
                    break
                }
            }

            return allNameIsWithMinLength
        },
        uploadSubCategoryIcon: function(thisEvent) {
            let thisVue = this
            for (const key in thisEvent.target.files) {
                const thisNewImage = thisEvent.target.files[key]
                if (typeof thisNewImage != 'object') continue;
                else if (key == 'length') continue;
                else if (thisNewImage.type.indexOf('image') != 0) continue;

                const reader = new FileReader();
                reader.onload = function() {
                    const base64 = this.result.replace(/.*base64,/, '');
                    thisVue.createSubCategory.icon = base64
                };
                reader.readAsDataURL(thisNewImage);
                break;
            }
            thisEvent.target.value = ''
        }
    },
    watch: {
        '$store.state.languages': {
            handler: function(newLangObj, oldLangObj) {
                for (const key in newLangObj) {
                    if (!this.createSubCategory.name.hasOwnProperty(key)) {
                        this.createSubCategory.name[key] = ''
                    }
                }
            },
            deep: true
        }
    },
    mounted: function() {
        this.$emit('updateSubCategoryList')

        for (const key in this.$store.state.languages) {
            if (!this.createSubCategory.name.hasOwnProperty(key)) {
                this.createSubCategory.name[key] = ''
            }
        }
    }
}
</script>

<style>

</style>